import "prebid.js/modules/richaudienceBidAdapter";

import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {RichAudienceAdUnit} from "header-bidding-base/modules/config/domain/bidders/richAudienceConfig";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import {PrebidJsBaseBidder} from "./prebidJsBaseBidder";

export class RichAudienceBidder extends PrebidJsBaseBidder implements IPrebidJsBidder<RichAudienceAdUnit> {
    public constructor(config: HeaderBiddingConfig) {
        super(config, Bidders.RICHAUDIENCE);
    }
}
